import type { WidgetDefinition } from '../WidgetDefinition';
import { faCalendarRange } from '@fortawesome/pro-regular-svg-icons/faCalendarRange';
import type { EventsWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';
import type { EventsWidgetViewModel } from 'src/store/types';

class EventsWidgetDefinition implements WidgetDefinition<EventsWidgetViewModel, EventsWidgetModel> {
    type = 'events' as const;
    nameKey = 'widgets::events::name' as const;
    roles = ['widgets::events'];
    icon = faCalendarRange;
    category = 'widgets::categories::research' as const;
    defaultDimensions = { h: 0.8, w: 0.33, x: 0.33, y: 0.1 };

    /**
     * Converts an Events widget from contract model to view model
     */
    toViewModel(widget: EventsWidgetModel): EventsWidgetViewModel {
        return {
            ...widget,
            slowIdeaId: widget.slowIdeaId ?? null,
            fastIdeaIds: widget.fastIdeaIds ?? [],
            gotoDate: null,
            displayingCalendar: widget.displayingCalendar ?? false,
            splitPercentage: widget.splitPercentage ?? 50,
            type: 'events',
        };
    }

    /**
     * Converts an Events widget from view model to contract model
     */
    toContractModel(widget: EventsWidgetViewModel): EventsWidgetModel {
        const { gotoDate: _gotoDate, ...contractWidget } = widget;
        return contractWidget;
    }
}

export const eventsWidgetDefinition = new EventsWidgetDefinition();
